// Is that text a private key?
//
// Shared by the add-worker wizard's resolver and the Settings key library's, so
// pasting the wrong file is refused the same way in both — and, more to the
// point, refused here rather than after a round trip that ends in OpenSSH's own
// "invalid format" minutes into a deploy.

/**
 * The public half of a pair, as opposed to the private one.
 *
 * This is the mistake worth naming, because the `.pub` file is the one operators
 * normally copy around: it is what goes into `authorized_keys`, so it is what is
 * already on the clipboard.
 */
const PUBLIC_KEY_PREFIX = /^(ssh-|ecdsa-|sk-)/;

/** A message naming what is wrong, or null when the text looks like a key. */
export function privateKeyIssue(value: string): string | null {
	const key = value.trim();
	if (key.length === 0) return "Paste the private key for this machine";
	if (PUBLIC_KEY_PREFIX.test(key)) {
		return "That is the public key. Paste the private one — the same file without the .pub suffix.";
	}
	if (!key.includes("-----BEGIN")) {
		return "That does not look like a private key file";
	}
	return null;
}
